import { render } from "./MenuSidebarItem.vue?vue&type=template&id=2c72878c&scoped=true"
import script from "./MenuSidebarItem.vue?vue&type=script&lang=js"
export * from "./MenuSidebarItem.vue?vue&type=script&lang=js"

import "./MenuSidebarItem.vue?vue&type=style&index=0&id=2c72878c&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c72878c"]])

export default __exports__